module.exports = __webpack_public_path__ + "static/media/main-001.b8b4bbc0.jpg";